import { apiRequest } from './api';
import { IFuncionario } from '../types';

export interface MapaPontoServico {
  id: number;
  tipo: string;
  status: string;
  coordenadas_inst: string;
  contrato_id: number;
  conexao?: 'Online' | 'Offline' | null;
  plano?: { nome: string };
  contrato?: {
    id: number;
    titulo: string;
    cliente_id: number;
    cliente?: {
      id: number;
      nome: string;
    };
  };
}

export interface MapaPontoCto {
  id: number;
  name: string;
  latitude: number | string;
  longitude: number | string;
  capacidade: number | null;
  cto_status: 'online' | 'offline' | 'vazia';
  monitor_ultimo_online_em?: string | null;
  monitor_ultimo_offline_em?: string | null;
}

export interface MapaPontosData {
  servicos: MapaPontoServico[];
}

export const monitoramentoService = {
  // Obter clientes para o mapa de monitoramento
  getClientes: async (): Promise<MapaPontoServico[]> => {
    const response = await apiRequest.get<MapaPontoServico[]>('/monitoramento/getclientes');
    return response.data || [];
  },
  
  // Obter CTOs para o mapa
  getCtos: async (): Promise<MapaPontoCto[]> => {
    const response = await apiRequest.get<MapaPontoCto[]>('/monitoramento/getctos');
    return response.data || [];
  },

  // Obter técnicos para o mapa
  getTecnicos: async (): Promise<IFuncionario[]> => {
    const response = await apiRequest.get<IFuncionario[]>('/monitoramento/gettecnicos');
    return response.data || [];
  }
};
